import { useState, useEffect } from 'react';

export const useUrlValidation = ({ urlValue = '' }, validUrlPattern) => {
  const [hasUrl, sethasUrl] = useState(null);

  useEffect(() => {
    const pattern = new RegExp(validUrlPattern);

    sethasUrl(pattern.test(urlValue));
  }, [urlValue]);

  return [hasUrl];
};
